// extracted by mini-css-extract-plugin
export default {"capitalLetter":"noFlightsBlock-module__capitalLetter__wMeW2"};